import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { configure } from 'mobx';
import { App } from './routes/app';

// enable MobX strict mode
configure({ enforceActions: true });

ReactDOM.render(<App />, document.getElementById('app'));
